/* LumiSmile PDP: afsendelsestekst + nedtælling. Ingen afhængigheder. */
(function () {
  function dkNow() {
    var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Copenhagen', hour: 'numeric', minute: 'numeric', hour12: false, weekday: 'short' }).formatToParts(new Date());
    var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
    return { mins: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10), day: o.weekday };
  }
  document.querySelectorAll('[data-ls-ship]').forEach(function (el) {
    var n = dkNow();
    var cutoff = (parseInt(el.getAttribute('data-cutoff'), 10) || 14) * 60 + (parseInt(el.getAttribute('data-cutoff-min'), 10) || 0);
    var before = n.mins < cutoff, d = n.day, key;
    if (d === 'Sat' || d === 'Sun' || (d === 'Fri' && !before)) key = 'data-monday';
    else key = before ? 'data-today' : 'data-tomorrow';
    var txt = el.querySelector('.ls-ship__txt');
    if (txt) txt.textContent = el.getAttribute(key);
  });
  document.querySelectorAll('[data-ls-cd]').forEach(function (el) {
    var end = parseInt(el.getAttribute('data-end'), 10) * 1000;
    var out = el.querySelector('[data-ls-cd-time]');
    var t;
    function pad(v) { return v < 10 ? '0' + v : '' + v; }
    function tick() {
      var d = end - Date.now();
      if (d <= 0) { el.remove(); clearInterval(t); return; }
      var s = Math.floor(d / 1000), days = Math.floor(s / 86400);
      s -= days * 86400;
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      out.textContent = (days > 0 ? days + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
    }
    tick(); t = setInterval(tick, 1000);
  });
  document.querySelectorAll('[data-ls-revs]').forEach(function (el) {
    var tr = el.querySelector('[data-ls-revs-track]');
    el.querySelectorAll('[data-ls-revs-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = tr.firstElementChild, step = card ? card.getBoundingClientRect().width + 12 : tr.clientWidth;
        tr.scrollBy({ left: step * parseInt(b.getAttribute('data-ls-revs-dir'), 10), behavior: 'smooth' });
      });
    });
  });
})();
